<template>
  <md-dialog :md-active.sync="showDialog" class="text-center">
    <md-dialog-title>Import Data</md-dialog-title>
    <template v-if="!uploadedFile">
      <div><input type="file" ref="file" accept=".xls,.xlsx"/></div>
      <div class="m-3">
        <button type="button" class="btn btn-primary m-3" @click="uploadImportFile()">Upload</button>
        <button type="button" class="btn btn-secondary m-3" @click="close()">Close</button>
      </div>
    </template>
    <template v-else>
      <div>{{ dataCount }} records are ready to import</div>
      <div class="m-3">
        <button type="button" class="btn btn-primary m-3" @click="confirmImportFile()">Confirm</button>
        <button type="button" class="btn btn-secondary m-3" @click="close()">Close</button>
      </div>
    </template>
  </md-dialog>
</template>

<script>
export default {
  name: 'ImportModule',
  props: {
    uploadURL: String,
    confirmURL: String,
  },
  data() {
    return {
      showDialog: false,
      processing: false,
      dataCount: null,
      uploadedFile: null,
    }
  },
  methods: {
    close() {
      this.uploadedFile = null
      this.dataCount = null
      this.showDialog = false
    },
    uploadImportFile() {
      let formData = new FormData()
      let file = this.$refs.file.files[0]

      if( file !== 'undefined') {

        this.processing = true

        formData.append('file', file)
        this.$http
          .post(this.uploadURL , formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((res) => {
            this.dataCount = res.data.dataCount
            this.uploadedFile = res.data.uploadedFile
            this.$refs.file.value = ''
          })
          .catch((err) => {
            this.alertNotice({
              type: 'danger',
              title: 'Failed',
              content: err.data,
            })
          })
          .finally(() => {
            this.processing = false
          })
      }

    },
    confirmImportFile() {
      this.processing = true
      this.$http
        .post(this.confirmURL, {filename: this.uploadedFile})
        .then((res) => {

          this.alertNotice({
            type: 'success',
            title: 'Success',
            content: res.data + ' records has been import successfully',
          })

          this.showDialog = false
          this.dataCount = null
          this.uploadedFile = null

          this.$emit('reload')

        })
        .catch((err) => {
          this.alertNotice({
            type: 'danger',
            title: 'Failed',
            content: err.data,
          })
        })
        .finally(() => {
          this.processing = false
        })
    },
  },
}
</script>
<style>

</style>